module.exports = __webpack_public_path__ + "img/2019_innovation.103d17d3.jpg";